import React from 'react';
import { TITLE_LABEL, MIN_PRODUCT_LABEL } from '../ARSConstants';
import TextField from 'Components/DesignSystem/TextField/TextField';

type ModesSectionHeaderProps = {
    sectionLabel: string;
    title: string;
    minProduct: number;
    onTitleChange: (value: string) => void;
    onMinProductChange: (value: number) => void;
    disabled?: boolean;
    id?: string;
};

export const ModesSectionHeader = ({
    sectionLabel,
    title,
    minProduct,
    onTitleChange,
    onMinProductChange,
    disabled = false,
    id = 'modes-section-header'
}: ModesSectionHeaderProps) => {
    const handleTitleChange = (e: string) => {
        onTitleChange(e);
    };

    const handleMinProductChange = (e: string) => {
        const value = parseInt(e, 10);
        if (!isNaN(value) && value >= 1) {
            onMinProductChange(value);
        } else if (e === '') {
            onMinProductChange(1);
        }
    };

    const onBlur = (newValue: number, minValue: number, maxValue: number) => {
        if (minValue !== undefined && Number(newValue) < minValue) {
            onMinProductChange(minValue);
        } else if (maxValue !== undefined && Number(newValue) > maxValue) {
            onMinProductChange(maxValue);
        }
    }

    return (
        <div
            className="tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-gap-3 md:tw-gap-6 tw-pb-3"
            data-testid={id}
        >
            <div className="tw-text-gray-200 tw-text-sm tw-font-semibold tw-min-w-[120px]">
                {sectionLabel}
            </div>

            <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-gap-2 md:tw-gap-4 tw-flex-1">
                <div className="tw-flex tw-items-center tw-gap-2">
                    <label
                        htmlFor={`${id}-title-input`}
                        className="tw-text-[#6d788c] tw-text-sm tw-leading-tight"
                    >
                        {TITLE_LABEL}
                    </label>
                    <TextField
                        label=''
                        type="text"
                        value={title}
                        onChange={(e) => handleTitleChange(e)}
                        disabled={disabled}
                        className="tw-w-[200px] md:tw-w-[250px] tw-bg-white tw-rounded tw-text-[#172b4d] tw-text-sm tw-font-semibold disabled:tw-bg-gray-100 disabled:tw-cursor-not-allowed"
                        data-testid={`${id}-title-input`}
                    />
                </div>

                <div className="tw-flex tw-items-center tw-gap-2 tw-ml-auto">
                    <label
                        htmlFor={`${id}-min-product-input`}
                        className="tw-text-[#6d788c] tw-text-sm tw-leading-tight"
                    >
                        {MIN_PRODUCT_LABEL}
                    </label>
                    <TextField
                        label=''
                        type="number"
                        minValue={1}
                        maxValue={100}
                        value={String(minProduct)}
                        onChange={handleMinProductChange}
                        onBlur={() => { onBlur(minProduct, 1, 100) }}
                        disabled={disabled}
                        data-testid={`${id}-min-product-input`}
                    />
                </div>
            </div>
        </div>
    );
};

export default ModesSectionHeader;